import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-perche-sceglierci',
  templateUrl: './perche-sceglierci.component.html',
  styleUrls: ['./perche-sceglierci.component.scss']
})


export class PercheSceglierciComponent  implements OnInit {
  private sub: any;
 


  constructor(    private meta: Meta  ){

    
    this.meta.updateTag({ name: 'title', content: 'Perchè sceglierci?' });
    this.meta.updateTag({ name:'description', content:'IL NOSTRO SERVIZIO DI CONSULENZA TELEFONICA PER RISPARMIARE SULLA BOLLETTA È ECCELLENTE E SOPRATTUTTO GRATUITO! '});
    this.meta.updateTag({ name: 'keywords', content: 'Abolizione Mercato Tutelato , Mercato  libero, Consulenza Grauita, Assistenza Clienti, Risparmio in bolletta' });
  }
  ngOnInit() {
     

  }
}



// WEBPACK FOOTER //
// ./src/app/perche-sceglierci/perche-sceglierci.component.ts